import { render, staticRenderFns } from "./CartUpSellItem.vue?vue&type=template&id=3a616592"
import script from "./CartUpSellItem.vue?vue&type=script&lang=js"
export * from "./CartUpSellItem.vue?vue&type=script&lang=js"
import style0 from "./CartUpSellItem.vue?vue&type=style&index=0&id=3a616592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports